module.exports = __webpack_public_path__ + "media/packs/images/state/completed-da3a4e72ce98e9355c96ff255bff350a.svg";